
import {
  defineComponent,
  ref,
  onMounted,
  computed,
  watchEffect,
  reactive,
} from "vue";
import { appColors } from "@/config/globals";
import useBreakpoints from "@/services/Breakpoints";
import { useStore } from "vuex";
import { SpeakerData } from "@/models/events/speakers/speakerData";

export default defineComponent({
  props: ["programsData"],
  setup() {
    const store = useStore();
    const colors = computed(() => {
      const eventData = store.getters["user/eventData"];
      if (eventData.themeSettings) {
        if (eventData.themeSettings.cardColor1) {
          const cardColor1 = eventData.themeSettings.cardColor1;
          const cardColor2 = eventData.themeSettings.cardColor2;
          const cardColor3 = eventData.themeSettings.cardColor3;
          const cardColor4 = eventData.themeSettings.cardColor4;
          const eventColors: Array<string> = [];
          for (let index = 0; index < 4; index++) {
            eventColors.push(cardColor1);
            eventColors.push(cardColor2);
            eventColors.push(cardColor3);
            eventColors.push(cardColor4);
          }
          return eventColors;
        }
        return appColors;
      }
      return appColors;
    });
    const { type } = useBreakpoints();
    const eventData = computed(() => {
      return store.getters["user/eventData"];
    });
    const speakerData: Array<SpeakerData> = reactive([]);
    const getMainSpeaker = (data) =>
      store.dispatch("speakers/getMainSpeaker", data);

    const fillSpeakers = (speakers) => {
      speakerData.splice(0, speakerData.length);
      for (const speaker of speakers) {
        speakerData.push(speaker);
      }
    };
    function cutString(text, number) {
      var cut = text.indexOf(" ", number);
      if (cut == -1) return text;
      return text.substring(0, cut);
    }

    onMounted(async () => {
      if (eventData.value) {
        const data = await getMainSpeaker({
          eventData: eventData.value.id,
        });
        fillSpeakers(data);
      }
    });

    watchEffect(async () => {
      if (eventData.value) {
        if (eventData.value.id)
          if (speakerData.length === 0) {
            const data = await getMainSpeaker({
              eventData: eventData.value.id,
            });
            fillSpeakers(data);
          }
      }
    });
    return {
      colors,
      type,
      speakerData,
      cutString,
    };
  },
});
